export const getRouteWithParams = (route: string) => {
    return `${route}${window.location.search}`
}
